module.exports = __webpack_public_path__ + "img/service16.7caab53f.svg";